module.exports = __webpack_public_path__ + "img/imgWj.79d2cbb7.jpg";